module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Новости")]), _vm._v(" "), _c('entity-manager', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data": _vm.news,
      "options": _vm.newsEntityManagerOptions
    },
    scopedSlots: _vm._u([{
      key: "dataItemFieldTableView",
      fn: function(viewProps) {
        return [(viewProps.column.field == 'createdAt') ? _c('span', [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(viewProps.dataRow.val[viewProps.column.field])) + "\n        ")]) : (viewProps.column.field == 'author') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.users[viewProps.dataRow.val[viewProps.column.field]].Name) + "\n        ")]) : ((viewProps.column.field == 'topical') || (viewProps.column.field == 'publish')) ? _c('span', [_vm._v("\n          " + _vm._s(viewProps.dataRow.val[viewProps.column.field] === true ? 'Да' : 'Нет') + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(viewProps.dataRow.val[viewProps.column.field]) + "\n      ")])]
      }
    }, {
      key: "dataItemFieldEditView",
      fn: function(viewProps) {
        return [(viewProps.fieldKey == 'name') ? _c('span', [_c('Input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "Заглавие новости"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1) : (viewProps.fieldKey == 'body') ? _c('div', {
          staticClass: "EDT5"
        }, [_c('vue-html5-editor', {
          attrs: {
            "content": viewProps.editingDataRow.val[viewProps.fieldKey],
            "height2": "350"
          },
          on: {
            "change": function(val) {
              viewProps.editingDataRow.val[viewProps.fieldKey] = val
            }
          }
        })], 1) : (viewProps.fieldKey == 'author') ? _c('span', [_c('Select', {
          attrs: {
            "filterable": "",
            "placeholder": "Выберите автора",
            "size2": "large"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        }, _vm._l((_vm.users), function(item) {
          return (item != null) ? _c('Option', {
            key: item.id,
            attrs: {
              "value": item.id
            }
          }, [_vm._v(_vm._s(item.Name))]) : _vm._e()
        }))], 1) : ((viewProps.fieldKey == 'topical') || (viewProps.fieldKey == 'publish')) ? _c('span', [_c('Checkbox', {
          staticStyle: {
            "padding-bottom": "5px"
          },
          attrs: {
            "size": "small"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1) : ((viewProps.fieldKey == 'updatedAt') || (viewProps.fieldKey == 'createdAt')) ? _c('span', [_c('DatePicker', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "datetime",
            "placeholder": "Выберите дату и время"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1) : _c('span', [((viewProps.editingDataRow.val[viewProps.fieldKey] == null) || (viewProps.editingDataRow.val[viewProps.fieldKey] === '')) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v("\n          " + _vm._s(viewProps.editingDataRow.val[viewProps.fieldKey]) + "\n        ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f78a26","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminPanel/News.vue
// module id = 399
// module chunks = 0